import * as i0 from '@angular/core';
import { Component, Input, NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Esta clase sirve para generar las propiedades relacionadas por el icono. Es utilizada por el [Icon Component]{@link IconComponent}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
class IconGenerator {
    /**
     * Esta función obtiene la clase del icono a partir del nombre del icono y el nombre de la fuente
     *
     * @param iconName Nombre del icono
     * @param fontName Nombre de la fuente
     * @return
     */
    getIconClassName(iconName, fontName = this.defaultFontName) {
        return `${fontName} ${fontName}-${iconName}`;
    }
    /**
     * Esta función obtiene la clase del decorador del icono a partir del decorador 'decorator' de tipo DecoratorTypes
     * que se le pasa como parámetro
     *
     * @param decorator Decorador del icono a aplicar
     * @return
     */
    getIconDecoratorClassName(decorator) {
        switch (decorator) {
            case 'circle':
                return 'iconDecoratorCircle';
            case 'square':
                return 'iconDecoratorSquare';
            default:
                return null;
        }
    }
    /**
     * Esta función obtiene la template a partir del nombre del icono, el nombre de la fuente y el decorador
     *
     * @param iconName Nombre del icono
     * @param decorator Decorador del icono a aplicar
     * @param fontName Nombre de la fuente
     * @return
     */
    getTemplate(iconName, tooltip = '', iconClasses, decorator, fontName = this.defaultFontName) {
        let decoratorClasses = this.getIconDecoratorClassName(decorator);
        let iconClassName = this.getIconClassName(iconName, fontName);
        if (!decoratorClasses) {
            decoratorClasses = '';
        }
        else {
            decoratorClasses += ' ';
        }
        decoratorClasses += this.baseClassDecorator;
        return `<div class='${decoratorClasses} ${iconClasses}'>
              <i class="${iconClassName}" title="${tooltip}" class='alignMiddle'></i>
            </div>`;
    }
    /**
     * Esta función obtiene el nombre por defecto de la fuente
     *
     * @return
     */
    get defaultFontName() {
        return 'ucc-icons';
    }
    /**
     * Esta función obtiene la clase por defecto del decorador
     *
     * @return
     */
    get baseClassDecorator() {
        return 'baseIcon';
    }
}

/**
 * Este componente se utiliza para la declaración de iconos en la aplicación. Se le debe pasar el icono a mostrar y, de manera
 * opcional, se le pueden pasar clases, decoradores, y fuentes.
 *
 * @example
 * <ucc-icon [key]='iconName'></ucc-icon>
 */
class IconComponent {
    constructor() {
        this._iconGenerator = new IconGenerator();
        this._key = 'cloud';
        this._fontName = null;
        this._decorator = null;
        this._iconClass = null;
        this._iconClassesName = null;
        this._iconKeyClassName = null;
        /** Permite definir el color del icono. Si no se define ninguno tendrá el color predeterminado de los estilos del icono */
        this.iconColor = null;
        /** Permite definir el tamaño del icono. Si no se define ninguno tendrá el tamaño predeterminado de los estilos del icono */
        this.iconSize = null;
        /** Permite definir el color de fondo del icono. Si no se define ninguno tendrá el color predeterminado de los estilos del icono */
        this.iconBackgroundColor = null;
    }
    ngOnInit() {
        this.generateIconClasses();
        this.generateIconKeyClassName();
    }
    generateIconClasses() {
        let iconClasses = new Array();
        let iconDecoratorClassName = this._iconGenerator.getIconDecoratorClassName(this.decorator);
        if (iconDecoratorClassName) {
            iconClasses.push(iconDecoratorClassName);
        }
        if (this.iconClass) {
            iconClasses.push(this.iconClass);
        }
        iconClasses.push(this._iconGenerator.baseClassDecorator);
        this._iconClassesName = iconClasses;
    }
    generateIconKeyClassName() {
        this._iconKeyClassName = this._iconGenerator.getIconClassName(this.key, this.fontName);
    }
    /**
     * Permite obtener la clase decoradora del icono
     */
    get iconClass() {
        return this._iconClass;
    }
    /**
     * Permite definir la clase decoradora del icono
     *
     * @param value La clase decoradora del icono
     */
    set iconClass(value) {
        this._iconClass = value;
        this.generateIconClasses();
    }
    /**
     * Permite obtener el identificador único del icono. Es el campo que define que icono aparece en el componente
     */
    get key() {
        return this._key;
    }
    /**
     * Permite definir el identificador único del icono. Es el campo que define que icono aparece en el componente
     *
     * @param value El identificador único del icono
     */
    set key(value) {
        this._key = value;
        this.generateIconKeyClassName();
    }
    /**
     * Permite obtener la fuente de iconos del componente. Si es null, obtiene el valor predeterminado definido en la aplicación
     */
    get fontName() {
        return this._fontName ? this._fontName : this._iconGenerator.defaultFontName;
    }
    /**
     * Permite definir la fuente de iconos del componente
     *
     * @param value La fuente de iconos del componente
     */
    set fontName(value) {
        this._fontName = value;
        this.generateIconKeyClassName();
    }
    /**
     * Permite obtener el decorador opcional del componente. Se pueden escoger los definidos en [DecoratorTypes]{@link DecoratorTypes}
     */
    get decorator() {
        return this._decorator;
    }
    /**
     * Permite definir el decorador opcional del componente. Se pueden escoger los definidos en [DecoratorTypes]{@link DecoratorTypes}
     *
     * @param value El decorador opcional del componente
     */
    set decorator(value) {
        this._decorator = value;
        this.generateIconClasses();
    }
    /** @ignore */
    get iconKeyClassName() {
        return this._iconKeyClassName;
    }
    /** @ignore */
    get iconClassesName() {
        return this._iconClassesName;
    }
}
IconComponent.ɵfac = function IconComponent_Factory(t) { return new (t || IconComponent)(); };
IconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconComponent, selectors: [["ucc-icon"]], inputs: { iconColor: "iconColor", iconSize: "iconSize", iconBackgroundColor: "iconBackgroundColor", iconClass: "iconClass", key: "key", fontName: "fontName", decorator: "decorator" }, decls: 2, vars: 8, consts: [[3, "ngClass"], [1, "alignMiddle", 3, "ngClass"]], template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.iconClassesName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("color", ctx.iconColor)("font-size", ctx.iconSize, "px")("background-color", ctx.iconBackgroundColor);
        ɵngcc0.ɵɵproperty("ngClass", ctx.iconKeyClassName);
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
IconComponent.propDecorators = {
    iconColor: [{ type: Input }],
    iconSize: [{ type: Input }],
    iconBackgroundColor: [{ type: Input }],
    iconClass: [{ type: Input }],
    key: [{ type: Input }],
    fontName: [{ type: Input }],
    decorator: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-icon',
                template: "<div [ngClass]='iconClassesName'>\r\n  <i [ngClass]=\"iconKeyClassName\"\r\n     [style.color]=\"iconColor\"\r\n     [style.font-size.px]=\"iconSize\"\r\n     [style.background-color]=\"iconBackgroundColor\"\r\n     class='alignMiddle'>\r\n  </i>\r\n</div>"
            }]
    }], function () { return []; }, { iconColor: [{
            type: Input
        }], iconSize: [{
            type: Input
        }], iconBackgroundColor: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], key: [{
            type: Input
        }], fontName: [{
            type: Input
        }], decorator: [{
            type: Input
        }] }); })();

class IconModule {
}
IconModule.ɵfac = function IconModule_Factory(t) { return new (t || IconModule)(); };
IconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IconModule });
IconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    IconComponent
                ],
                exports: [
                    IconComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IconModule, { declarations: function () { return [IconComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconComponent]; } }); })();

class UccIconsService {
    constructor() { }
}
UccIconsService.ɵfac = function UccIconsService_Factory(t) { return new (t || UccIconsService)(); };
/** @nocollapse */ UccIconsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function UccIconsService_Factory() { return new UccIconsService(); }, token: UccIconsService, providedIn: "root" });
/** @nocollapse */
UccIconsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UccIconsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { IconComponent, IconGenerator, IconModule, UccIconsService };

